// Sur web, le require local fonctionne directement via webpack.
export const cameraImage = require('./camera.png');
